module.exports = __webpack_public_path__ + "images/stickers/taco-clean@2x.7c593a77fe481b61a2ca.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-clean@2x.png
// module id = wLQJ
// module chunks = 12